export default {
  scenes: {
    meetingTheGroom: {
      beats: {
        chanceEncounter: {
          events: [
            {
              type: 'showLocation',
              locationId: 'weddingVenue'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'My apologies, Mr. Whitmore. I was just inspecting the final touches.',
              choices: [
                {
                  text: 'Professional Approach',
                  next: {
                    scene: 'meetingTheGroom',
                    beat: 'professionalApproach'
                  }
                },
                {
                  text: 'Friendly and Warm',
                  next: {
                    scene: 'meetingTheGroom',
                    beat: 'friendlyApproach'
                  }
                }
              ]
            }
          ]
        },
        professionalApproach: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'daniel',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'happy',
              text: 'No worries, Miss Carter. Call me Daniel.'
            },
            {
              type: 'hideCharacter',
              characterId: 'daniel',
              position: 'center'
            }
          ],
          next: {
            scene: 'meetingTheGroom',
            beat: 'smallTalk'
          }
        },
        friendlyApproach: {
          events: [
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'happy',
              text: 'Well, if you\'re sneaking around before the big day, I\'m not responsible for any bad luck.'
            },
            {
              type: 'showCharacter',
              characterId: 'daniel',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'happy',
              text: 'Just making sure everything\'s perfect.'
            },
            {
              type: 'hideCharacter',
              characterId: 'daniel',
              position: 'center'
            }
          ],
          next: {
            scene: 'meetingTheGroom',
            beat: 'smallTalk'
          }
        },
        smallTalk: {
          events: [
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Everything is running on schedule. You have nothing to worry about.'
            },
            {
              type: 'showCharacter',
              characterId: 'daniel',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'neutral',
              text: 'I trust you. You seem like the kind of person who ensures perfection.'
            },
            {
              type: 'hideCharacter',
              characterId: 'daniel',
              position: 'center'
            }
          ],
          next: {
            scene: 'theBridesExcitement',
            beat: 'finalWeddingPreparations'
          }
        }
      }
    },
    theBridesExcitement: {
      beats: {
        finalWeddingPreparations: {
          events: [
            {
              type: 'showLocation',
              locationId: 'bridalSuite'
            },
            {
              type: 'showCharacter',
              characterId: 'emily',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'You\'re going to make the most beautiful bride, Emily. Everything is perfect.',
              choices: [
                {
                  text: 'Encourage Her Excitement',
                  next: {
                    scene: 'theBridesExcitement',
                    beat: 'encourageExcitement'
                  }
                },
                {
                  text: 'Keep It Businesslike',
                  next: {
                    scene: 'theBridesExcitement',
                    beat: 'keepBusinesslike'
                  }
                }
              ]
            }
          ]
        },
        encourageExcitement: {
          events: [
            {
              type: 'showDialog',
              speaker: 'emily',
              variation: 'happy',
              text: 'Thank you! I can\'t believe the day is finally here.'
            }
          ],
          next: {
            scene: 'theBridesExcitement',
            beat: 'dressFitting'
          }
        },
        keepBusinesslike: {
          events: [
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Let\'s go over the final details to make sure everything goes smoothly.'
            },
            {
              type: 'showDialog',
              speaker: 'emily',
              variation: 'neutral',
              text: 'Yes, I just want to make sure everything is exactly right.'
            }
          ],
          next: {
            scene: 'theBridesExcitement',
            beat: 'dressFitting'
          }
        },
        dressFitting: {
          events: [
            {
              type: 'showEffect',
              effect: 'motionLines',
              rotation: 0,
              duration: 1,
              waitUntilFinish: true
            },
            {
              type: 'showDialog',
              speaker: 'emily',
              variation: 'happy',
              text: 'I never thought I\'d meet someone like him. He\'s my soulmate.'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'That\'s all anyone could wish for.'
            },
            {
              type: 'showNarration',
              text: '(internal thought: Then why did my heart just clench?)'
            },
            {
              type: 'hideCharacter',
              characterId: 'emily',
              position: 'center'
            }
          ],
          next: {
            scene: 'firstUnspokenSpark',
            beat: 'lingeringMoment'
          }
        }
      }
    },
    firstUnspokenSpark: {
      beats: {
        lingeringMoment: {
          events: [
            {
              type: 'showLocation',
              locationId: 'gardenTerrace'
            },
            {
              type: 'showEffect',
              effect: 'vignette',
              intensity: 0.3
            },
            {
              type: 'showCharacter',
              characterId: 'daniel',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Everything is set for tomorrow. You should get some rest.',
              choices: [
                {
                  text: 'Keep Things Professional',
                  next: {
                    scene: 'firstUnspokenSpark',
                    beat: 'keepProfessional'
                  }
                },
                {
                  text: 'Acknowledge the Connection',
                  next: {
                    scene: 'firstUnspokenSpark',
                    beat: 'acknowledgeConnection'
                  }
                }
              ]
            }
          ]
        },
        keepProfessional: {
          events: [
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'neutral',
              text: 'Right. Big day and all.'
            }
          ],
          next: {
            scene: 'firstUnspokenSpark',
            beat: 'departure'
          }
        },
        acknowledgeConnection: {
          events: [
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'It\'s beautiful out here.'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'thinking',
              text: 'It is.'
            },
            {
              type: 'showNarration',
              text: '(long pause)'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'neutral',
              text: 'I should go.'
            }
          ],
          next: {
            scene: 'firstUnspokenSpark',
            beat: 'departure'
          }
        },
        departure: {
          events: [
            {
              type: 'hideCharacter',
              characterId: 'daniel',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'thinking',
              text: 'This is nothing. It has to be nothing.'
            },
            {
              type: 'showNarration',
              text: '(internal thought)'
            },
            {
              type: 'hideEffect',
              effect: 'vignette'
            }
          ],
          goToChapter: {
            chapter: 'chapter2'
          }
        }
      }
    }
  }
}
